import _extends from "@babel/runtime/helpers/extends";
import React, { forwardRef, useImperativeHandle, useRef } from 'react';
import Checkbox from '../checkbox';
import { RadioGroupContext } from './group';
import { useMergeProps } from '../checkbox/hooks';
export function componentGenerator(Comp) {
  return /*#__PURE__*/forwardRef(function (props, ref) {
    var mergedProps = useMergeProps(props, RadioGroupContext);
    var radioRef = useRef(null);
    useImperativeHandle(ref, function () {
      return radioRef.current;
    });
    return /*#__PURE__*/React.createElement(Comp, _extends({
      ref: radioRef
    }, mergedProps, {
      isRadio: true
    }));
  });
}
export var Radio = componentGenerator(Checkbox);